import StaticPageHeader from "../../Common/StaticPageHeader";

const ContactUs = () => {
  return (
    <>
      <StaticPageHeader />
      <div className="container my-3">
        <div className="row">
          <div className="col-12 text-center">
            <h2>Contact Us</h2>
            <p className="lead">We'd love to hear from you!</p>
          </div>
          <div className="col-md-8 mx-auto">
            <div className="card shadow-sm p-4">
              <form>
                <div className="mb-3">
                  <label htmlFor="name" className="form-label">Name</label>
                  <input type="text" className="form-control" id="name" placeholder="Your Name" />
                </div>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">Email address</label>
                  <input type="email" className="form-control" id="email" placeholder="name@example.com" />
                </div>
                <div className="mb-3">
                  <label htmlFor="message" className="form-label">Message</label>
                  <textarea className="form-control" id="message" rows={5} placeholder="Your message here..."></textarea>
                </div>
                <button type="submit" className="primary-btn w-100">Send Message</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
